// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"0e4111e3","825":"150195b2"}[chunkId] + ".chunk.css";
};